import { render, staticRenderFns } from "./lotto-reward.vue?vue&type=template&id=561fec74"
import script from "./lotto-reward.vue?vue&type=script&lang=js"
export * from "./lotto-reward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561fec74')) {
      api.createRecord('561fec74', component.options)
    } else {
      api.reload('561fec74', component.options)
    }
    module.hot.accept("./lotto-reward.vue?vue&type=template&id=561fec74", function () {
      api.rerender('561fec74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lotto-reward/lotto-reward.vue"
export default component.exports